import React, {FC} from "react";
import {useMainTranslation} from "../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {Box, Grid} from "@mui/material";
import {FrameworkAdoptCard} from "../../components/frameworkAdoptCard";
import {FrameworkAvailableCard} from "../../components/frameworkAvailableCard";
import {useMedia} from "../../../../../newShared/hooks/useMedia";
import {FrameworkSkeletonCard} from "../../components/frameworkSkeletonCard";
import {useAvailableFrameworksPage} from "./hooks/useAvailableFrameworksPage";
import {PageWrapper} from "../../../../../newShared/components/Layouts";
import {PageTitleAndActions} from "../../../../../newShared/components/pageTitleAndActions";
import {GenericFiltersArray} from "../../../../../newShared/components/genericFilter";

export const AvailableFrameworks: FC = () => {
    const {t, revDir} = useMainTranslation('', {keyPrefix: 'pathFrameworks'});
    const {matches_2300Up} = useMedia();

    const {
        frameworks,
        isLoading,
        // searchValue, handleChange, handleKeyDown, setFilter,
        bottomLoader, onScroll, scrollRef,
        fetchByFilters
    } = useAvailableFrameworksPage();

    return (
        <PageWrapper sx={{paddingBottom: '10px'}}>
            <PageTitleAndActions
                title={t('Frameworks')}
                actions={[]}
            />
            {/*<Breadcrumbs/>*/}
            {/*<Typography variant={!matches_1440Down ? "h1" : "h3"}>{t('Frameworks')}</Typography>*/}

            {/*<SearchField onClear={() => {setFilter('input'); handleChange({target: {value: ''}})}}*/}
            {/*             value={searchValue} onKeyDown={handleKeyDown} onChange={handleChange} disabled={isLoading}*/}
            {/*             sx={{marginTop: '16px', maxWidth: !isMobile ? '320px' : undefined}}/>*/}

            <GenericFiltersArray
                configs={[]}
                fetchResultWithSelectedFilters={fetchByFilters}
                isAddFilters={false}
            />

            <Box width={'100%'} display={"flex"} flexDirection={"column"} flexGrow={1} overflow={'auto'} onScroll={onScroll} ref={scrollRef} padding={!revDir ? '0 10px 0 0' : '0 0 0 10px'}>
                <Grid container spacing={2} mt={'16px'} columns={matches_2300Up ? 10 : undefined} sx={{'&>.MuiGrid-item': !revDir ? {paddingLeft: '17px'} : {paddingRight: '17px'}}}>
                    {frameworks.map((framework, index) => framework ? (
                        <Grid item key={framework.id} c390={12} c770={6} c1336={3} c1440={4} c1920={3} c2300={2}>
                            {framework.isAdded ? <FrameworkAdoptCard framework={framework}/> : <FrameworkAvailableCard framework={framework}/>}
                        </Grid>
                    ) : <FrameworkSkeletonCard key={'loading ' + index}/>)}

                    {(bottomLoader || isLoading) && (
                        <Grid item c390={12} c770={6} c1336={3} c1440={4} c1920={3} c2300={2}>
                            <FrameworkSkeletonCard/>
                        </Grid>
                    )}
                </Grid>
            </Box>
        </PageWrapper>
    )
}